import sendApiRequest from '../helpers/axios-setup';

/**
 *
 * @returns
 */
export async function getBatchExecution(query) {
    try {
        const response = await sendApiRequest.get('/batch-execution', {
            params: {
                ...query
            }
        });
        return response.data?.data;
    } catch (e) {
        return null;
    }
};

/**
 *
 * @returns
 */
export async function bulkPublishBatchExecution(batches) {
    try {
        const response = await sendApiRequest.post('/batch-execution/bulk/publish', {batches});
        return response.data?.data;
    } catch (e) {
        return null;
    }
}